<template>
  <div
    :class="{ is_mobile: !$tools.isPc() }"
    class="page_middle_container page_middle_project_detail"
  >
    <div class="page_middle_title">结算审批</div>
    <div class="page_middle_content">
      <div class="page_middle_body">
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>项目号：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              {{ data.project_number }}
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>客户名称：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              {{ data.customer_company }}
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>结算日期：
            </div>
            <div class="page_middle_row_value">
              <el-date-picker
                :disabled="true"
                value-format="YYYY-MM-DD"
                v-model="data.settlement_date"
                type="date"
                placeholder="请选择结算日期"
                size="small"
              />
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>结算金额：
            </div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                v-model="data.settlement_amount"
                placeholder="0.00"
              >
                <template #suffix>
                  <el-tooltip
                    effect="dark"
                    :content="getChineseMoney"
                    placement="top-end"
                  >
                    <div>元(查看大写)</div>
                  </el-tooltip>
                </template>
              </el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>是否需要盖章：
            </div>
            <div class="page_middle_row_value">
              <el-radio-group disabled v-model="data.need_stamp">
                <el-radio :label="1" size="small">是</el-radio>
                <el-radio :label="0" size="small">否</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td" v-if="data.need_stamp == 1">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>盖章文件份数：
            </div>
            <div class="page_middle_row_value">
              <el-input disabled v-model="data.stamp_num"></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span
              >是否需要邮寄原件：
            </div>
            <div class="page_middle_row_value">
              <el-radio-group disabled v-model="data.need_original">
                <el-radio :label="1" size="small">是</el-radio>
                <el-radio :label="0" size="small">否,电子版即可</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">邮寄地址：</div>
            <div class="page_middle_row_value">
              <el-input
                style="width: 100%"
                disabled
                v-model="data.mail_address"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td" style="align-items: flex-start">
            <div class="page_middle_row_key">补充信息：</div>
            <div class="page_middle_row_value">
              <el-input
                disabled
                type="textarea"
                v-model="data.supplementary_information"
                rows="3"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">结算单/结算材料附件：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.settlement_attachment">
                <div v-for="(item, index) in settlementAttachment" :key="index">
                  <!-- <a :href="item" target="_blank">{{
                    $tools.getFileNameFromURL(item)
                  }}</a> -->
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">交付物/结算物料(如幻灯、DA等)附件：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.settlement_materials">
                <div v-for="(item, index) in settlementMaterials" :key="index">
                  <!-- <a :href="item" target="_blank">{{
                    $tools.getFileNameFromURL(item)
                  }}</a> -->
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
        <div class="page_middle_row">
          <div class="page_middle_row_td">
            <div class="page_middle_row_key">
              <span class="page_middle_row_key_required">*</span>合同/po附件：
            </div>
            <div class="page_middle_row_value" style="padding-left: 15px;">
              <div v-if="data.po_contract_url" style="width: 100%">
                <div v-for="(item, index) in poContractUrls" :key="index">
                  <!-- <a :href="item" target="_blank">{{
                    $tools.getFileNameFromURL(item)
                  }}</a> -->
                  <span class="global_link" @click="openLink(item)">
                    {{ $tools.getFileNameFromURL(item) }}
                  </span>
                </div>
              </div>
              <div v-else>无</div>
            </div>
          </div>
        </div>
        <div v-if="data.examine_status == 0 && !query.isWatch">
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required">*</span>审批结果：
              </div>
              <div class="page_middle_row_value">
                <el-select
                  v-model="auditData.examine_status"
                  placeholder="请选择审批结果"
                >
                  <el-option :value="1" label="通过"></el-option>
                  <el-option :value="2" label="驳回"></el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                <span class="page_middle_row_key_required" v-if="auditData.examine_status == 2">*</span>审批备注：
              </div>
              <div class="page_middle_row_value">
                <el-input
                  v-model.trim="auditData.examine_reason"
                  placeholder="请输入审批备注"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                审批结果：
              </div>
              <div class="page_middle_row_value" style="padding-left: 15px;display: flex;align-items: center;">
                <el-icon style="font-size: 4vw;color: #67c23a;margin-right: 5px;" v-if="data.examine_status == 1"><SuccessFilled /></el-icon>
                <el-icon style="font-size: 4vw;color: red;margin-right: 5px;" v-if="data.examine_status == 2"><CircleCloseFilled /></el-icon>
                <span>
                  {{ $config.types.auditResult[data.examine_status] }}
                </span>
              </div>
            </div>
          </div>
          <div class="page_middle_row">
            <div class="page_middle_row_td">
              <div class="page_middle_row_key">
                审批备注：
              </div>
              <div class="page_middle_row_value" style="padding-left: 15px;">
                {{ data.examine_reason }}
              </div>
            </div>
          </div>
          <div v-if="data.examine_status == 1">
            <div class="page_middle_row">
              <div class="page_middle_row_td">
                <div class="page_middle_row_key">
                  盖章结算单/结算材料附件：
                </div>
                <div class="page_middle_row_value" style="flex: 1 0 0;">
                    <Attachment
                      class="zIndexBold"
                      @changeFile="changeFile"
                      @deleteFile="deleteFile"
                      :isLink="true"
                      :showUpload="!query.isWatch && !isSettlementCheck"
                      :files="stampSettlementAttachment"
                      type="project"
                      :required="config.settlementAttachmentRequired"
                    ></Attachment>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="page_middle_buttongroup"
      v-if="data.examine_status == 0 && !query.isWatch"
    >
      <el-button type="primary" @click="doCommit" :loading="loading"
        >提交</el-button
      >
    </div>
  </div>
</template>
<script>
import Attachment from "@/components/unit/attachment";
import { SuccessFilled, CircleCloseFilled } from "@element-plus/icons";
export default {
  name: "page_middle",
  data() {
    return {
      auditData: {
        id: "",
        examine_status: "",
        examine_reason: "",
        operation_url: window.location.href,
      },
      data: {
        project_id: "",
        customer_id: "",
        customer_company: "",
        project_number: "",
        settlement_date: "",
        settlement_amount: 0,
        need_stamp: 0,
        stamp_num: 0,
        need_original: 0,
        mail_address: "",
        supplementary_information: "",
        settlement_attachment: "",
        settlement_materials:"",
        stamp_settlement_attachment:"",
        po_contract_url: "",
      },
      config: {
        status: this.$config.types.status,
        isRequired: {
          isRequired: false,
          title: "请添加结算单/结算材料附件：",
        },
        settlementAttachmentRequired: {
          isRequired: true,
          title: "",
        }
      },
      settlementAttachment: [],
      settlementMaterials:[],
      stampSettlementAttachment:[],
      poContractUrls: [],
      loading: false,
    };
  },
  components: {
    Attachment,
    SuccessFilled, 
    CircleCloseFilled 
  },
  created() {
    this.query = { ...this.$route.query };
  },
  computed: {
    getChineseMoney() {
      let moneyText = this.$tools.numberToChinese(this.data.settlement_amount);
      return moneyText;
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      let url = this.$tools.getURL(
        this.$urls.settlement.get_settlement_detail,
        { id: this.query.id }
      );
      this.$axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.auditData.id = res.data.id;
          this.isSettlementCheck = this.data.stamp_settlement_attachment != "";
          this.poContractUrls = this.data.po_contract_url ? this.data.po_contract_url.split(",") : [];
          this.settlementAttachment = this.data.settlement_attachment ? this.data.settlement_attachment.split(",") : [];
          this.settlementMaterials = this.data.settlement_materials ? this.data.settlement_materials.split(",") : [];
          this.stampSettlementAttachment = this.data.stamp_settlement_attachment ? this.data.stamp_settlement_attachment.split(",") : [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSettlementInfo() {
      let url = this.$tools.getURL(this.$urls.settlement.get_settlement_info, {
        project_id: this.data.project_id,
      });
      this.$axios
        .get(url)
        .then((res) => {
          this.data = { ...this.data, ...res.data };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openLink(url) {
      this.$tools.downLoadFile(url);
    },
    // 上传附件
    changeFile(res) {
      if (res.index != 0) {
        this.stampSettlementAttachment.splice(res.index - 1, 1,...res.data.data);
      }else{
        this.stampSettlementAttachment = this.stampSettlementAttachment.concat(
          res.data.data
        );
      }
      this.data.stamp_settlement_attachment = this.stampSettlementAttachment.join(",");
    },
    // 删除附件
    deleteFile(res) {
      this.stampSettlementAttachment.splice(res.index, 1);
      this.data.stamp_settlement_attachment = this.stampSettlementAttachment.join(",");
    },
    verifyData() {
      if (!this.auditData.examine_status) {
        this.$tips.error({ text: "请选择审批结果" });
        return false;
      }
      if (
        this.auditData.examine_status == 2 &&
        !this.auditData.examine_reason
      ) {
        this.$tips.error({ text: "请输入审批备注" });
        return false;
      }
      return true;
    },
    doCommit() {
      if (this.loading || !this.verifyData()) {
        return;
      }
      this.loading = true;
      let url = this.$urls.settlement.settlement_audit;
      this.$axios
        .post(url, this.auditData)
        .then(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          this.$tips.success({ text: "审核完成" });
          this.initData();
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
  },
};
</script>
<style>
.page_middle_project_detail .page_middle_row_value {
  display: flex;
  align-items: center;
  flex: 1 0 0;
}
.flex-column {
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-justify-content-start {
  justify-content: start;
}

.zIndexBold {
  z-index: 1000;
  position: relative;
}

.is_mobile * {
  font-size: 1.25rem;
}

.is_mobile .page_middle_row {
  align-items: initial;
  flex-direction: column;
}

.is_mobile .page_middle_row .page_middle_row_td {
  margin-bottom: 10px;
}

.is_mobile .project_number_input {
  flex-direction: initial;
  align-items: center;
}

.is_mobile .page_middle_row_td_textarea .el-textarea {
  width: 60%;
}

.is_mobile .page_middle_row_key.page_middle_row_key_left {
  text-align: left;
  flex: 50px 0 0;
}
</style>
  